import { List, ListItem as ListItemBase } from "twyne-new.ui"

const ListItem = ({ children }) => <ListItemBase>
  <div className='grid grid-cols-4 gap-2 items-center w-full'>
    {children}
  </div>
</ListItemBase>

const ListWrapper = ({ children }) => <List className='pt-0'>
  {children}
</List>

const ListLabel = ({ children }) => <div className='col-span-1 flex gap-1'>{children}</div>

const ListContent = ({ children }) => <div className='col-span-3'>{children}</div>

export {
  ListWrapper,
  ListItem,
  ListLabel,
  ListContent,
}
